/* eslint-disable import/prefer-default-export */
import { DELETE_ANNOUNCEMENT, GET_ANNOUNCEMENT, GET_EXPIRED_ANNOUNCEMENTS, SHOW_ANNOUNCEMENT, SET_ANNOUNCEMENT_LOADER } from "./constants";

const initialState = {
  activeAnnouncement: {
    id: "",
    announcement: "",
    date: "",
    time: "",
    color: "#7ADBD1",
    link: "",
    timer: 1,
  },
  showAnnouncement: true,
  expiredAnnouncements: [],
  loading: false,
};

export const announcement = (state = initialState, action = { type: "", payload: "" }) => {
  switch (action.type) {
    case GET_ANNOUNCEMENT: {
      return {
        ...state,
        activeAnnouncement: action.payload,
      };
    }
    case DELETE_ANNOUNCEMENT: {
      return {
        ...state,
        activeAnnouncement: {
          id: "",
          announcement: "",
          date: "",
          time: "",
          color: "#7ADBD1",
          link: "",
          timer: 1,
        },
      };
    }
    case GET_EXPIRED_ANNOUNCEMENTS: {
      return {
        ...state,
        expiredAnnouncements: action.payload,
      };
    }
    case SHOW_ANNOUNCEMENT: {
      return {
        ...state,
        showAnnouncement: action.payload,
      };
    }
    case SET_ANNOUNCEMENT_LOADER: {
      return {
        ...state,
        loading: action.payload,
      };
    }

    default:
      return state;
  }
};
